<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="total-stat">
    <div class="total-stat-count">
      <span v-if="!slide.showAsGraph && !slide.showAgentNames" :class="alertType">{{
        kpiFormat(groupedAgents, 'number')
      }}</span>

      <EcsAgentsStatesGraph v-if="slide.showAsGraph" :states="groupedAgents" :class="alertType" />

      <EcsAgentsStatesNames v-if="slide.showAgentNames" :states="groupedAgents" />
    </div>
    <div v-if="!slide.showAsGraph && !slide.showAgentNames" class="total-stat-description">
      <span v-for="(state, i) in slide.states" :key="state">
        {{ state }}<span v-if="i < slide.states.length - 1">, </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsAgentsStatesGraph from './EcsAgentsStatesGraph.vue';
import EcsAgentsStatesNames from './EcsAgentsStatesNames.vue';
import EcsKpiFormatter from '@/mixins/ecs-kpi-formatter/EcsKpiFormatter';

export default {
  name: 'EcsAgentsStatesSlide',
  components: {
    EcsAgentsStatesGraph,
    EcsAgentsStatesNames
  },

  mixins: [EcsKpiFormatter],

  props: {
    slide: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  computed: {
    ...mapGetters('WALLBOARD', ['getStatisticsByBpids', 'getWallboardStatistics']),

    ...mapGetters('SUPERVISOR', ['getSupervisedAgents']),

    alertType() {
      const POSSIBLE_STATES_TYPES = [
        'availableAgents',
        'onBreakAgents',
        'busyAgents',
        'handleOutgoingAgents',
        'noAnswerAgents',
        'backofficeAgents'
      ];
      let slideAlertType = 'None';

      if (this.selectedBusinessProcessesStats) {
        POSSIBLE_STATES_TYPES.every(stateType => {
          if (this.selectedBusinessProcessesStats[stateType].alertType === 'Alert') {
            slideAlertType = this.selectedBusinessProcessesStats[stateType].alertType;
            return false;
          } else if (this.selectedBusinessProcessesStats[stateType].alertType === 'Warning') {
            slideAlertType = this.selectedBusinessProcessesStats[stateType].alertType;
          }
          return true;
        });
      }
      return 'alert-type-' + slideAlertType.toLowerCase();
    },

    selectedBusinessProcessesStats() {
      return this.getStatisticsByBpids(this.slide.businessProcesses);
    },

    states() {
      const states = this.slide.states.map(state => {
        if (state === 'Handle Outgoing') {
          state = 'Handling - Outgoing Interactions';
        } else if (state === 'Backoffice') {
          state = 'Backoffice - Administrative';
        }
        return state;
      });
      return states.sort();
    },

    availableBusinessProcesses() {
      return this.getWallboardStatistics
        .filter(bp => this.slide.businessProcesses.includes(bp.businessProcessId))
        .map(bp => bp.businessProcessName);
    },

    groupedAgents() {
      const grouped = {};
      this.states.forEach(state => {
        grouped[state] = [];
      });

      const countStatesByAgents = this.getSupervisedAgents.reduce((grouped, agent) => {
        const state = agent.agentState;

        if (
          agent.assignedBP.split(', ').some(assignedBP => {
            return this.availableBusinessProcesses.includes(assignedBP);
          }) &&
          this.states.includes(state)
        ) {
          if (grouped[state]) {
            grouped[state].push({
              agentId: agent.agentId,
              agentName: agent.agentName,
              agentState: state
            });
          }
        }

        return grouped;
      }, grouped);

      if (this.slide.showAgentNames) {
        return countStatesByAgents;
      } else if (this.slide.showAsGraph) {
        return this.countByState(countStatesByAgents, this.states);
      }

      return Object.keys(countStatesByAgents).reduce((acc, state) => acc + countStatesByAgents[state].length, 0);
    }
  },

  methods: {
    countByState(stats, states) {
      const initialData = {};
      const POSSIBLE_STATES_TYPES = {
        Ready: stats.Ready || 0,
        Break: stats.Break || 0,
        Busy: stats.Busy || 0,
        'Handling - Outgoing Interactions': stats['Handling - Outgoing Interactions'] || 0,
        'No Answer': stats['No Answer'] || 0,
        'Backoffice - Administrative': stats['Backoffice - Administrative'] || 0
      };

      return states.reduce((acc, state) => {
        if (POSSIBLE_STATES_TYPES[state]) {
          acc[state] = POSSIBLE_STATES_TYPES[state].length;
        }

        return acc;
      }, initialData);
    }
  }
};
</script>

<style src="../scoped.css" scoped></style>
